module.exports = __webpack_public_path__ + "img/99_7.bca09cdc.png";